<template>
  <div>
    <TableCCTVEquipment v-if="this.$route.query.type_name === 'CCTV'" />
    <TableEquipment v-else />
  </div>
</template>

<script>
import TableEquipment from '@/views/equipment/detail/TableEquipment.vue'
import TableCCTVEquipment from '@/views/equipment/detailCCTV/TableEquiment.vue'

export default {
  components: {
    TableEquipment,
    TableCCTVEquipment,
  },
}
</script>

  <style>

  </style>
